<template>
    <div>
        <Modal
            v-model="payVisible"
            :mask-closable="false"
            footer-hide
            width="520"
            class-name="center-pay-modal"
        >
            <div class="pay-modal">
                <Icon type="ios-close" class="pay-modal__close" @click="closePay" />
                <div class="pay-modal__header">
                    <img class="pay-modal__wx-icon" src="@/assets/setimg/weixin.png" alt="" />
                    <div class="pay-modal__title">请使用微信扫码付款</div>
                </div>

                <div class="pay-modal__price-wrap">
                    <span class="pay-modal__price">¥{{ formatPrice(payForm.price) }}</span>
                </div>

                <div class="pay-modal__qrcode">
                    <Spin fix v-if="!payQrcode && !payQrcodeFailed">
                        <Icon type="ios-loading" size="32" class="pay-modal__spin" />
                        <div class="pay-modal__loading-text">二维码加载中...</div>
                    </Spin>
                    <div v-else-if="payQrcodeFailed" class="pay-modal__qrcode-error">
                        <Icon type="ios-close-circle-outline" size="40" color="#ed4014" />
                        <div class="pay-modal__error-text">{{ payQrcodeErrorMsg }}</div>
                    </div>
                    <img v-else class="pay-modal__qrcode-img" :src="payQrcode" alt="支付二维码" />
                </div>

                <div class="pay-modal__tip">支付完成后将自动跳转，请勿关闭此窗口</div>
            </div>
        </Modal>

        <Modal
            v-model="paySuccessVisible"
            :mask-closable="false"
            footer-hide
            width="520"
            class-name="center-pay-modal"
        >
            <div class="pay-success">
                <Icon type="ios-close" class="pay-modal__close" @click="paySuccessVisible = false" />
                <img class="pay-success__icon" src="@/assets/setimg/zhifuwancheng.png" alt="" />
                <div class="pay-success__title">恭喜你支付完成!</div>
                <div class="pay-success__card">
                    <div class="pay-success__row">
                        <span class="pay-success__label">商品订单</span>
                        <span class="pay-success__value">{{ payResult.order_no }}</span>
                    </div>
                    <div class="pay-success__row">
                        <span class="pay-success__label">商品名称</span>
                        <span class="pay-success__value">{{ payResult.version_name }}</span>
                    </div>
                    <div class="pay-success__row">
                        <span class="pay-success__label">支付金额</span>
                        <span class="pay-success__value pay-success__value--price">¥{{ payResult.pay_money }}</span>
                    </div>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import { cs_chargepay, get_orderstatus, get_menulist } from '@/api/center'
import { get_userinfo } from '@/api/versionPackage'
import { getApiErrorMsg, applyUserSession } from '@/utils/helper'

export default {
    name: 'VersionPackagePayModal',
    data() {
        return {
            payVisible: false,
            paySuccessVisible: false,
            payQrcode: '',
            payQrcodeFailed: false,
            payQrcodeErrorMsg: '',
            payTimer: null,
            payForm: { price: '' },
            payResult: { order_no: '', pay_money: '', version_name: '' },
            isRenewal: false
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo
        }
    },
    beforeDestroy() {
        this.clearPayTimer()
    },
    methods: {
        formatPrice(value) {
            if (value == null || value === '') return '0'
            const num = Number(value)
            if (Number.isNaN(num)) return String(value)
            if (num === 0) return '0'
            const fixed = Number.isInteger(num) ? String(num) : num.toFixed(2)
            return fixed.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '')
        },
        open(plan, options = {}) {
            if (!plan) return
            this.isRenewal = !!options.isRenewal
            const payPrice = this.isRenewal ? plan.renewal_fee : plan.price
            this.payForm = { price: this.formatPrice(payPrice) }
            this.payResult.version_name = plan.version_name
            this.payVisible = true
            this.payQrcode = ''
            this.payQrcodeFailed = false
            this.payQrcodeErrorMsg = ''
            this.startPay(plan)
        },
        onPayQrcodeFailed(msg) {
            this.payQrcodeFailed = true
            this.payQrcodeErrorMsg = msg
            this.$Message.error(msg)
        },
        startPay(plan) {
            cs_chargepay({
                application_id: plan.id || plan.saas_version_id,
                price_id: plan.id || plan.saas_version_id,
                uniacid_id: this.userInfo.uniacid_id,
                payment_type: 1,
                type: 0,
                order_source: 'version'
            }).then(res => {
                const data = res && res.data
                if (!data || !data.qrcode_url) {
                    this.onPayQrcodeFailed('获取支付二维码失败')
                    return
                }
                this.payQrcode = data.qrcode_url
                this.pollingOrder(data.out_trade_no)
            }).catch(res => {
                this.onPayQrcodeFailed(getApiErrorMsg(res, '发起支付失败'))
            })
        },
        pollingOrder(orderNo) {
            this.clearPayTimer()
            this.payTimer = setInterval(() => {
                this.$store.commit('changePollingSpin', false)
                get_orderstatus({ order_no: orderNo }).then(res => {
                    if (res.data.is_pay == 1) {
                        this.onPaySuccess(res)
                        this.clearPayTimer()
                    }
                    this.$store.commit('changePollingSpin', true)
                }).catch(res => {
                    this.$store.commit('changePollingSpin', true)
                    this.$Message.error((res && res.msg) || '查询支付状态失败')
                    this.clearPayTimer()
                })
            }, 2000)
        },
        onPaySuccess(res) {
            this.payVisible = false
            this.paySuccessVisible = true
            this.payResult.order_no = res.data.order_no
            this.payResult.pay_money = res.data.pay_money
            this.syncSessionAfterPay()
            this.$emit('paid')
        },
        syncSessionAfterPay() {
            get_userinfo().then(res => {
                const data = res.data || {}
                const applied = applyUserSession(this.$store, data)
                if (!applied || !data.menus || !data.unique_auth) {
                    this.refreshMenu()
                }
            }).catch(() => {
                this.refreshMenu()
            })
        },
        refreshMenu() {
            get_menulist().then(res => {
                this.$store.commit('setAuth', res.data.unique_auth)
                this.$store.commit('setMenus', res.data.menuAll)
            }).catch(() => {})
        },
        closePay() {
            this.payVisible = false
            this.payQrcodeFailed = false
            this.payQrcodeErrorMsg = ''
            this.isRenewal = false
            this.clearPayTimer()
        },
        clearPayTimer() {
            if (this.payTimer) {
                clearInterval(this.payTimer)
                this.payTimer = null
            }
        }
    }
}
</script>

<style lang="scss">
.pay-modal {
    position: relative;
    text-align: center;
    padding: 8px 12px 4px;
}

.pay-modal__close {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
    font-size: 28px;
    color: #999;
    cursor: pointer;
    line-height: 1;
    transition: color 0.2s;

    &:hover {
        color: #666;
    }
}

.pay-modal__header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 20px;
}

.pay-modal__wx-icon {
    width: 28px;
    height: 28px;
}

.pay-modal__title {
    font-size: 18px;
    font-weight: 600;
    color: #545f78;
    line-height: 1.4;
}

.pay-modal__price-wrap {
    margin-bottom: 28px;
}

.pay-modal__price {
    position: relative;
    display: inline-block;
    padding: 0 28px;
    font-size: 32px;
    font-weight: 700;
    color: #4877e8;
    line-height: 1.2;

    &::before,
    &::after {
        content: '';
        position: absolute;
        top: 50%;
        width: 120px;
        border-bottom: 1px solid #d6e3ff;
    }

    &::before {
        right: 100%;
        margin-right: 8px;
    }

    &::after {
        left: 100%;
        margin-left: 8px;
    }
}

.pay-modal__qrcode {
    position: relative;
    width: 200px;
    height: 200px;
    margin: 0 auto;
    padding: 8px;
    border: 1px solid #4877e8;
    border-radius: 8px;
    background: #fff;
    box-sizing: border-box;
}

.pay-modal__qrcode-img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.pay-modal__spin {
    animation: center-pay-spin 1s linear infinite;
    color: #4877e8;
}

.pay-modal__loading-text {
    margin-top: 10px;
    font-size: 13px;
    color: #8a94a6;
}

.pay-modal__qrcode-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 12px;
    box-sizing: border-box;
}

.pay-modal__error-text {
    margin-top: 10px;
    font-size: 13px;
    color: #ed4014;
    line-height: 1.5;
    word-break: break-all;
}

.pay-modal__tip {
    margin-top: 20px;
    font-size: 13px;
    color: #8a94a6;
    line-height: 1.5;
}

.pay-success {
    position: relative;
    text-align: center;
    padding: 8px 8px 16px;
}

.pay-success__icon {
    width: 72px;
    height: 72px;
    margin-bottom: 12px;
}

.pay-success__title {
    font-size: 22px;
    font-weight: 700;
    color: #2f3a4f;
    margin-bottom: 24px;
}

.pay-success__card {
    text-align: left;
    background: #f7f9fc;
    border-radius: 8px;
    padding: 16px 20px;
    border: 1px solid #e9edf6;
}

.pay-success__row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 8px 0;
    font-size: 14px;
    line-height: 1.5;

    & + & {
        border-top: 1px dashed #e3e8f0;
    }
}

.pay-success__label {
    flex-shrink: 0;
    color: #8a94a6;
}

.pay-success__value {
    color: #2f3a4f;
    text-align: right;
    word-break: break-all;

    &--price {
        font-weight: 700;
        color: #fe511c;
    }
}

@keyframes center-pay-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.center-pay-modal {
    .ivu-modal-body {
        padding: 28px 32px 32px;
        overflow: visible;
    }

    .ivu-modal-close {
        display: none;
    }
}
</style>
